import * as React from "react";
import { CreateNGAdvancedGeneral } from "./create_ng_advanced_general";
import { CreateNGAdvancedName } from "./create_ng_advanced_name";
import { CreateNGAdvancedPorts } from "./create_ng_advanced_ports";
import { CreateNGAdvancedWorkloadSubdomain } from "./create_ng_advanced_workloadSubdomain";
import { CreateNGAdvancedGvcSubdomain } from "./create_ng_advanced_gvcSubdomain";
import { CreateNGDryRunChecker } from "./create_ng_dryRunChecker";
import { CreateNGAdvancedPortsDedicatedLBCheck } from "./create_ng_advanced_ports_dlb_check";
import { CreateNGAdvancedPathBasedGvc } from "./create_ng_advanced_pathBasedGvc";
import { CreateNGAdvancedAcceptAllDedicatedLBCheck } from "./create_ng_advanced_acceptAll_dlb_check";
import { CreateNGSaveCreate } from "./create_ng_saveCreate";
import { CreateNGCancelReset } from "./craete_ng_cancelReset";
import { CreateNGPreview } from "./create_ng_preview";
import { FormDryRunAlert } from "./formDryRunAlert";
import { Domain } from "../../../schema/types/domain/entity";

interface Props {
  domain?: Domain;
}
export const CreateNGAdvanced: React.FC<Props> = ({ domain }) => {
  return (
    <>
      <CreateNGAdvancedName />
      <CreateNGAdvancedGeneral />
      <CreateNGAdvancedAcceptAllDedicatedLBCheck />
      <CreateNGAdvancedGvcSubdomain key={"gvcSubdomain"} />
      <CreateNGAdvancedWorkloadSubdomain key={"workloadSubdomain"} />
      <CreateNGAdvancedPathBasedGvc key={"pathBased"} />
      <CreateNGAdvancedPortsDedicatedLBCheck />
      <CreateNGAdvancedPorts />
      <CreateNGDryRunChecker />
      <FormDryRunAlert
        path={``}
        paths={[
          //
          `spec`,
        ]}
      />
      <div className="grid grid-cols-3 gap-4 mt-4" style={{ width: 600 }}>
        <CreateNGCancelReset domain={domain} />
        <CreateNGPreview />
        <CreateNGSaveCreate domain={domain} />
      </div>
    </>
  );
};
